import React from 'react';
import { Users } from 'lucide-react';

// Placeholder – será expandido com a listagem de clientes e integração CRM
export default function Clientes() {
  return (
    <div className="max-w-4xl mx-auto py-12 px-4">
      <div className="flex items-center gap-3 mb-6">
        <Users size={28} className="text-[#064E3B]" />
        <h1 className="text-2xl font-bold text-stone-900" style={{ fontFamily: 'Playfair Display, serif' }}>
          Clientes
        </h1>
      </div>
      <div className="bg-white border border-stone-200 rounded-xl p-8 text-center text-stone-500">
        <p className="text-lg font-medium mb-2">Módulo em desenvolvimento</p>
        <p className="text-sm">Aqui você gerenciará seus clientes, importará listas CSV e integrará com seu CRM.</p>
      </div>
    </div>
  );
}
